import React, { useCallback, useRef } from 'react'
import ChartControls from './ChartControls'
import ChartFeedback from './ChartFeedback'
import ChartVisualizationArea from './ChartVisualizationArea'

const Chart = React.memo(({
  chartAreaRef,
  selectedDevices,
  selectedMeasurements,
  data,
  series,
  annotations,
  chartDataLoading,
  error,
  handleDevicesChange,
  availableDevices,
  deviceMeasurementsMap,
  devicesLoading,
  devicesError,
  handleMeasurementsChange,
  availableMeasurements,
  measurementsLoading,
  handleClearSelections,
  timeRange,
  configLoading,
  onTimeRangeChange,
  isExternallySetCustom,
  onExternalCustomProcessed,
  onExportData,
}) => {
  const debounceTimeoutRef = useRef()

  const handleXAxisRangeUpdateInternal = useCallback((min, max) => {
    if (debounceTimeoutRef.current) clearTimeout(debounceTimeoutRef.current)
    debounceTimeoutRef.current = setTimeout(() => {
      onTimeRangeChange({ type: 'absolute', startTime: new Date(min), endTime: new Date(max), duration: 'custom' })
    }, 500)
  }, [onTimeRangeChange])

  return (
    <>
      <ChartControls
        selectedDevices={selectedDevices}
        handleDevicesChange={handleDevicesChange}
        availableDevices={availableDevices}
        deviceMeasurementsMap={deviceMeasurementsMap}
        devicesLoading={devicesLoading}
        devicesError={devicesError}
        selectedMeasurements={selectedMeasurements}
        handleMeasurementsChange={handleMeasurementsChange}
        availableMeasurements={availableMeasurements}
        measurementsLoading={measurementsLoading}
        handleClearSelections={handleClearSelections}
        timeRange={timeRange}
        onTimeRangeChange={onTimeRangeChange}
        chartDataLoading={chartDataLoading}
        configLoading={configLoading}
        error={error}
        isExternallySetCustom={isExternallySetCustom}
        onExternalCustomProcessed={onExternalCustomProcessed}
        onExportData={onExportData}
      />

      <ChartFeedback
        message={error}
        isSuccess={data.length > 0 || (error && error.startsWith('Selections cleared'))}
        showResetButton={error && error.includes('No data available')}
        onResetSelections={handleClearSelections}
      />

      <ChartVisualizationArea
        ref={chartAreaRef}
        show={selectedDevices.length > 0 && selectedMeasurements.length > 0}
        chartDataLoading={chartDataLoading}
        series={series}
        annotations={annotations}
        onXAxisRangeUpdate={handleXAxisRangeUpdateInternal}
      />
    </>
  )
})

Chart.displayName = 'Chart'

export default Chart
